import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import LandingPage from "./pages/LandingPage";
import ProtectedRoute from "./components/PrivateRoute";
import LoginAdmin from "./pages/LoginAdmin";
import Admin from "./pages/Admin";

const App: React.FC = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/admin/login" element={<LoginAdmin />} />

        <Route path="/admin" element={<ProtectedRoute element={<Admin />} />} />

        {/* Use ProtectedRoute for HomePage */}
        <Route path="/home" element={<ProtectedRoute element={<Home />} />} />
        {/* You can add more protected routes here */}
        <Route path="*" element={<div>Page Not Found</div>} />
      </Routes>
    </Router>
  );
};

export default App;
